import { useTranslation } from "react-i18next";
import { Select } from "../../../components/control/Select";
import { DraftActions } from "../../../drafts/DraftActions";
import { useWorkspaceDraft } from "../../../drafts/useWorkspaceDraft";
import { useBookDetail } from "../bookContext";
export function RenderSettingsForm() {
  const book = useBookDetail();
  const { t } = useTranslation("overview");
  const draft = useWorkspaceDraft(book.id, "settings", {
    ttsModel: book.ttsModel,
    stability: book.stability,
  });
  const locked = !!book.renderSettingsLockedAt || draft.applying || !draft.loaded;
  const modelOptions = [
    { value: "eleven_v3", label: t("edit.models.eleven_v3") },
    { value: "eleven_multilingual_v2", label: t("edit.models.eleven_multilingual_v2") },
  ];
  const stabilityOptions = [
    { value: "creative", label: t("edit.stabilityOptions.creative") },
    { value: "natural", label: t("edit.stabilityOptions.natural") },
    { value: "robust", label: t("edit.stabilityOptions.robust") },
  ];
  return (
    <div className="space-y-4">
      <Select
        label={t("edit.model")}
        value={draft.value.ttsModel}
        disabled={locked}
        options={modelOptions}
        onChange={(e) => {
          const v = e.target.value;
          if (v === "eleven_v3" || v === "eleven_multilingual_v2")
            draft.setValue((old) => ({ ...old, ttsModel: v }));
        }}
      />
      <Select
        label={t("edit.stability")}
        value={draft.value.stability}
        disabled={locked}
        options={stabilityOptions}
        onChange={(e) => {
          const v = e.target.value;
          if (v === "creative" || v === "natural" || v === "robust")
            draft.setValue((old) => ({ ...old, stability: v }));
        }}
      />
      {book.renderSettingsLockedAt ? <p>{t("edit.settingsLocked")}</p> : null}
      <DraftActions draft={draft} disabled={locked} />
    </div>
  );
}
